import React from "react";
import { Modal, Button } from "react-bootstrap";
import NewService from "./NewService";
import Choisiroperations from "./Choisiroperations";
import UpdateService from "./UpdateService";
import Blacklistclt from "./Blacklistclt";
import ReglementService from "./ReglementService";
import ReviewService from "./ReviewService";

export default function ModalNewService({ show, onClose, k, onAction }) {
  return (
    <>
      {/* Modal */}
      <Modal
        show={show}
        onHide={onClose}
        centered
        backdrop="static"
        size="xl"
        dialogClassName="custom-modal-dialog"
      >
        {(() => {
          if (!k) {
            // Si k est null → on ne charge rien
            return (
              <Modal.Body className="custom-modal-body">
                <p>Erreur : aucune donnée reçue.</p>
              </Modal.Body>
            );
          }

          const parts = k.split("@@");
          const state = parts[3];

          switch (state) {
            case "Check in":
              return (
                <Modal.Body className="custom-modal-body">
                  <NewService k={k} onClose={onClose} />
                </Modal.Body>
              );

            case "In service":
              return (
                <Modal.Body className="custom-modal-body">
                  <Choisiroperations
                    k={k}
                    onClose={onClose}
                    onAction={onAction} // ← ajout essentiel
                  />
                </Modal.Body>
              );

            case "Review":
              return (
                <Modal.Body className="custom-modal-body">
                  <ReviewService k={k} onClose={onClose} />
                </Modal.Body>
              );
            case "modify":
              return (
                <Modal.Body className="custom-modal-body">
                  <UpdateService k={k} onClose={onClose} />
                </Modal.Body>
              );
            case "payment":
              return (
                <Modal.Body className="custom-modal-body">
                  <ReglementService k={k} onClose={onClose} />
                </Modal.Body>
              );
            case "blacklist":
              return (
                <Modal.Body className="custom-modal-body">
                  <Blacklistclt k={k} onClose={onClose} />
                </Modal.Body>
              );
            default:
              return (
                <Modal.Body className="custom-modal-body">
                  <p>État inconnu : {state}</p>
                </Modal.Body>
              );
          }
        })()}
      </Modal>

      {/* Styles intégrés */}
      <style>{`
        .custom-modal-dialog {
          width: 100%;       /* prend toute la largeur possible */
          max-width: 95vw;   /* limite largeur écran */
          height: 95vh;      /* limite hauteur écran */
          margin: auto;      /* centre horizontalement */
        }

        .custom-modal-body {
          height: 100%;
          overflow-y: auto;   /* scroll si contenu dépasse */
          padding: 1rem;
          animation: zoomFade 0.3s ease;
        }

        @keyframes zoomFade {
          0% { opacity: 0; transform: scale(0.95); }
          100% { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </>
  );
}
